import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indicator-view',
  templateUrl: './indicator-view.component.html',
  styleUrls: ['./indicator-view.component.scss']
})
export class IndicatorViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
